import { Other, OtherList, TransitionElement } from '../../model/enums/transition-element';

export function isOther(te: TransitionElement): te is Other {
  return OtherList.includes(te as any);
}
